import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "svg-icon-wrapper" }

import {computed, ref} from 'vue';
    import InlineSvg from 'vue-inline-svg';
    import {Skeleton} from '@/logged/common/ui';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
        src: {type: String, required: true},
        canBeActive: {type: Boolean, default: true},
        size: {type: Number, default: 18},
        active: {type: Boolean},
        name: String,
        color: {type: String, default: 'var(--joy-color-neutral-60)'},
    },
  setup(__props) {

const props = __props;

_useCssVars(_ctx => ({
  "8152c1a8": (__props.size),
  "2a9e5598": (__props.color)
}))

    

    const activeState = computed(() => {
        return !!activeSrc.value && props.active;
    });

    const baseLoaded = ref(false);
    const activeLoaded = ref(false);

    function handleBaseIconLoaded() {
        baseLoaded.value = true;
    }

    function handleActiveIconLoaded() {
        activeLoaded.value = true;
    }

    const baseSrc = computed<string>(() => `https://dam.malt.com/navbar/icons/${props.src}.svg?version=5`);
    const activeSrc = computed<string | undefined>(() => {
        if (props.canBeActive) {
            return `https://dam.malt.com/navbar/icons/${props.src}_active.svg?version=5`;
        }
        return undefined;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!baseLoaded.value)
      ? (_openBlock(), _createBlock(_unref(Skeleton), {
          key: 0,
          width: `${__props.size}px`,
          height: `${__props.size}px`
        }, null, 8, ["width", "height"]))
      : _createCommentVNode("", true),
    (__props.canBeActive && activeSrc.value)
      ? (_openBlock(), _createBlock(_unref(InlineSvg), {
          key: 1,
          class: _normalizeClass([{active: activeState.value}, "svg-icon"]),
          src: activeSrc.value,
          alt: __props.name,
          onLoaded: handleActiveIconLoaded
        }, null, 8, ["class", "src", "alt"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(InlineSvg), {
      class: _normalizeClass([{active: !activeState.value}, "svg-icon"]),
      src: baseSrc.value,
      alt: __props.name,
      onLoaded: handleBaseIconLoaded
    }, null, 8, ["class", "src", "alt"])
  ]))
}
}

})